export const ControlSkeleton = () => (
  <div className='relative w-full pt-[100%] hover:cursor-pointer hover:opacity-80 rounded-[35px] flex items-center justify-start gap-[0px] bg-skeleton animate-pulse'>
    <div className='absolute top-0 left-0 flex flex-col items-between justify-center w-full h-[100%]'>
      <div className='grow flex items-center justify-center w-full rounded-[40px] text-center'>
        <div className=' w-[55px] h-[55px] flex items-center justify-center p-[3px] bg-skeleton-hi rounded-full'>
          <div className='absolute'>
            <div className='w-full h-[100%] rounded-[50%] flex items-center justify-center' />
          </div>
        </div>
      </div>

      <div className='grow jost leading-[0.8rem] text-center '>
        <div className='bg-skeleton-hi h-[20px] max-w-[70%] mx-auto rounded-xl' />
      </div>
    </div>
  </div>
)
